// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SingleTranscript_singleTranscriptWrapper__KO-hL {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin: 1rem 0;
}
@media screen and (min-width: 992px) {
  .SingleTranscript_singleTranscriptWrapper__KO-hL {
    margin: 2rem 0;
  }
}
.SingleTranscript_singleTranscriptWrapper__KO-hL .SingleTranscript_stickyHeader__4P5AB {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 16px;
  margin: 0 -16px;
  border-bottom: 2px solid #6ba7a8;
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 999;
}`, "",{"version":3,"sources":["webpack://./src/styles/SingleTranscript.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;AACF;AACE;EANF;IAOI,cAAA;EAEF;AACF;AAAE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,aAAA;EACA,eAAA;EACA,gCAAA;EACA,gBAAA;EACA,MAAA;EACA,sBAAA;EACA,YAAA;AAEJ","sourcesContent":[".singleTranscriptWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  margin: 1rem 0;\n\n  @media screen and (min-width: 992px) {\n    margin: 2rem 0;\n  }\n\n  .stickyHeader {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    padding: 16px;\n    margin: 0 -16px;\n    border-bottom: 2px solid #6ba7a8;\n    position: sticky;\n    top: 0;\n    background-color: #fff;\n    z-index: 999;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"singleTranscriptWrapper": `SingleTranscript_singleTranscriptWrapper__KO-hL`,
	"stickyHeader": `SingleTranscript_stickyHeader__4P5AB`
};
export default ___CSS_LOADER_EXPORT___;
